import AppointmentQuestionnairePage from "./AppointmentQuestionnairePage";

export default AppointmentQuestionnairePage;

export * from "./AppointmentQuestionnairePage";
